module.exports = __webpack_public_path__ + "img/gris.4b2ef5f4.jpeg";